<template>
  <v-data-table
    :headers="headers"
    :items="tasks"
    :page.sync="pagination.page"
    :items-per-page.sync="paginationTaskList.rowsPerPage"
    :loading="loading"
    loading-text=""
    :items-per-page-text="rowsPerPageText"
    :items-per-page-items="rowsPerPageItems"
    :header-props="{ sortIcon }"
    :footer-props="{ prevIcon, nextIcon,'items-per-page-options':rowsPerPageItems  }"
    class="elevation-2"
    @pagination="setRowsOnLocalStorage(dataTableTaskListId,paginationTaskList.rowsPerPage)"
    :class="{ 'no-show-permission': !userHasPermissionTo('show') }"
  >
    <template v-slot:item="props">
      <tr
        @click="$emit('viewTask', props.item)"
        :class="{ 'cursor-pointer': userHasPermissionTo('show') }"
      >
        <td>
          <activity-task-status-icon
            :status="props.item.state"
            :delayed="isDelayed(props.item)"
          />
        </td>

        <!--<td>{{ showDependencies(props.item) }}</td>-->

        <td>{{ props.item.title }}</td>

        <td>
          <span>{{ getUserName(props.item.user_assignee_id) }}</span>
        </td>

        <td>
          <span>{{ getFormattedDate(props.item.scheduled_date) }}</span>
        </td>
      </tr>
    </template>

    <template v-slot:pageText="props">
      {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
      {{ props.itemsLength }}
    </template>

    <template v-slot:no-data>
      <div v-if="loading" />
    </template>
  </v-data-table>
</template>

<script>
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { activitiesTasksDataMixin } from "@/mixins/field/activitiesTasksDataMixin";
import ActivityTaskStatusIcon from "@/components/FieldManagement/StatusIcon";
import { mapActions } from "vuex";

export default {
  name: "NetworkActivityTasksTable",

  components: { ActivityTaskStatusIcon },

  mixins: [activitiesTasksDataMixin, managementDatatableMixin],

  props: {
    activityUUID: String
  },

  data() {
    return {
      pagination: {
        sortBy: "id"
      },
      dataTableTaskListId: "dataTableTaskListId" ,
      paginationTaskList: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableTaskListId")
      },
      tasks: [],

      permissionName: "field_task"
    };
  },

  computed: {
    headers() {
      return [
        {
          text: this.$i18n.t("State"),
          align: "left",
          value: "state",
          width: "5%"
        },
        /*{
          text: this.$i18n.tc("Dependency", 2),
          value: "dependencies",
          width: "10%"
        },*/
        { text: this.$i18n.tc("Task", 1), value: "title", width: "60%" },
        {
          text: this.$i18n.tc("Assignee", 1),
          value: "user_assignee_id",
          width: "10%"
        },
        {
          text: this.$i18n.t("ScheduledFor"),
          value: "scheduled_date",
          width: "10%"
        }
      ];
    }
  },

  watch: {
    activityUUID(value) {
      if (value) {
        this.getTasksByActivityUUID();
      }
    }
  },

  created() {
    if (this.activityUUID) {
      this.getTasksByActivityUUID();
    }
  },

  methods: {
    ...mapActions(["fetchTasksByActivityUuid"]),

    async getTasksByActivityUUID() {
      this.loading = true;
      try {
        this.tasks = await this.fetchTasksByActivityUuid({ uuid: this.activityUUID });
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Content/Tabs/Activities/TasksListTable.vue